import React from 'react';
import { useSelector } from 'react-redux';
import { MODAL_IDS } from '@src/containers/Session/constants';
import getModals from '@src/containers/Session/selectors/getModals';
import { MessageCDynamicConfirm } from '@src/components/Message/connectors/dynamic';
import PopupCDefault from '../connectors/default';

const PopupCSpaceConfirm = () => {
	const [isLoading, setIsLoading] = React.useState(true);
	const modals = useSelector(getModals);
	const modal = modals[MODAL_IDS.CLAIM_CONFIRM];
	// Keep the last opened texts so they don't switch to defaults during the close animation
	const messagePropsRef = React.useRef({});

	if (modal?.isOpen) {
		const props = {};
		if (modal.title) props.title = modal.title;
		if (modal.text) props.text = modal.text;
		messagePropsRef.current = props;
	}

	const messageProps = messagePropsRef.current;

	const handleMount = React.useCallback(() => {
		setIsLoading(false);
	}, []);

	return (
		<PopupCDefault
			isCentred
			isPlated
			modalId={MODAL_IDS.CLAIM_CONFIRM}
			adaptive="message"
			isLoading={isLoading}
		>
			<MessageCDynamicConfirm onMount={handleMount} {...messageProps} />
		</PopupCDefault>
	);
};

export default PopupCSpaceConfirm;
